// ObiHub OS kabuğunun Finans menüsü: mevcut kenar menüsüyle aynı yollar ve yetki kuralları (çalışmayan bağlantı yok).
import { hasAnyPermission, permissionSet, withPanelBase } from "@/lib/authz";

const APPS = [
  { key: "home", label: "Merkez", icon: "grid", to: "/panel", requiredAny: ["dashboard.view"] },
  { key: "sales", label: "Satışlar", icon: "bag", to: "/panel/satislar/faturalar", requiredAny: ["billing.view", "billing.manage"] },
  { key: "finance", label: "Finans", icon: "bank", to: "/panel/finans", requiredAny: ["billing.view", "billing.manage", "reports.view"] },
  { key: "stock", label: "Stok", icon: "box", to: "/panel/stok", requiredAny: ["inventory.view", "inventory.manage"] },
  { key: "ai", label: "Zekâ", icon: "spark", to: "/panel/ai-intelligence", requiredAny: ["catalog.view", "catalog.manage"] },
  { key: "settings", label: "Ayarlar", icon: "cog", to: "/panel/ayarlar", requiredAny: ["settings.view", "settings.manage"] },
];
const FINANCE = [
  { key: "finance", label: "Finans merkezi", icon: "bank", to: "/panel/finans", requiredAny: ["billing.view", "billing.manage", "reports.view"] },
  { key: "customers", label: "Cari hesaplar", icon: "users", to: "/panel/musteriler", requiredAny: ["customers.view", "customers.manage"] },
  { key: "kasa", label: "Kasa ve bankalar", icon: "wallet", to: "/panel/kasa", requiredAny: ["billing.view", "billing.manage"] },
  { key: "sales-invoices", label: "Satış faturaları", icon: "doc", to: "/panel/satislar/fatura-olustur", requiredAny: ["billing.view", "billing.manage"] },
  { key: "incoming", label: "Gelen faturalar", icon: "in", to: "/panel/giderler/gelen-e-faturalar", requiredAny: ["billing.view", "billing.manage"] },
  { key: "reports", label: "Gelir ve gider", icon: "chart", to: "/panel/raporlar", requiredAny: ["reports.view"] },
];

const initials = (name) => String(name || "").trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toLocaleUpperCase("tr")).join("") || "?";

export function buildFinanceShell(user, pathname) {
  const granted = permissionSet(user);
  const allow = (it) => hasAnyPermission(granted, it.requiredAny);
  const link = ({ requiredAny, ...it }) => ({ ...it, to: withPanelBase(it.to, user, pathname) });
  return {
    org: { name: user?.company_name || user?.tenant_name || "ObiHub", sub: "Ön muhasebe" },
    apps: APPS.filter(allow).map((a) => ({ ...link(a), active: a.key === "finance" })),
    section: { title: "Finans", desc: "Cari, nakit ve belgeler", items: FINANCE.filter(allow).map((it) => ({ ...link(it), active: it.key === "incoming" })) },
    user: { initials: initials(user?.name || user?.full_name || user?.email), name: user?.name || user?.full_name || "", role: "" },
  };
}
